import React, { useState } from 'react';
import BulkCreateCouponDialog from './Dialog/BulkCreateCouponDialog';
import CreateCouponDialog from './Dialog/CreateCouponDialog';

export default function CouponCreate({
  data,
  onCreateButtonClicked,
  onBulkCreateButtonClicked,
}) {
  const [createCouponDialogOpen, setCreateCouponDialogOpen] = useState(false);
  const [loading] = useState(false);
  const [bulkUploadDialogOpen, setBulkUploadDialogOpen] = useState(false);

  const openCreateCouponDialog = () => {
    setCreateCouponDialogOpen(true);
  };

  const closeCreateCouponDialog = () => {
    setCreateCouponDialogOpen(false);
  };

  const openBulkUploadCouponDialog = () => {
    setBulkUploadDialogOpen(true);
  };

  const closeBulkUploadCouponDialog = () => {
    setBulkUploadDialogOpen(false);
  };

  const handleCreateCoupon = async (newCoupon) => {
    await onCreateButtonClicked(newCoupon);
    closeCreateCouponDialog();
  };

  const bulkCouponCreation = async (data) => {
    await onBulkCreateButtonClicked(data);
    closeBulkUploadCouponDialog();
  };
  return (
    <>
      <div className='flex gap-3'>
        <button
          className='px-4 py-2 rounded-md text-sm font-semibold transition-all duration-150 cursor-pointer'
          style={{
            backgroundColor: 'var(--primary-main)',
            color: 'var(--primary-contrast)',
            border: 'none',
          }}
          onClick={openCreateCouponDialog}
        >
          + Create New Coupon
        </button>
        <button
          className='px-4 py-2 rounded-md text-sm font-semibold transition-all duration-150 cursor-pointer'
          style={{
            backgroundColor: 'transparent',
            color: 'var(--text-secondary)',
            border: '1px solid var(--border-main)',
          }}
          onClick={openBulkUploadCouponDialog}
        >
          Bulk Coupon Create
        </button>
      </div>

      {bulkUploadDialogOpen && (
        <BulkCreateCouponDialog
          allCoupons={data}
          bulkCouponCreation={bulkCouponCreation}
          open={bulkUploadDialogOpen}
          handleCloseButton={closeBulkUploadCouponDialog}
          loading={loading}
        />
      )}
      {createCouponDialogOpen && (
        <CreateCouponDialog
          open={createCouponDialogOpen}
          onCreateButtonClicked={handleCreateCoupon}
          handleCloseButton={closeCreateCouponDialog}
        />
      )}
      {/* --- Form Dialog --- */}
    </>
  );
}
